export enum ReportParameter {
    START_DATE = 'startDate',
    END_DATE = 'endDate',
    AGGREGATION_LEVEL = 'aggregationLevel',
    STATE_IDS = 'stateIds',
    RUN_TIMES = 'runTimes',
    TEXT_SEARCH = 'textSearch',
}
